var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "route-project-form" }, [
    _c(
      "div",
      { staticClass: "padding-box" },
      [
        _c(
          "cms-heading",
          {
            staticClass: "page-heading",
            attrs: {
              level: "1",
              title: _vm.pageTitle,
              icon: "magicon-folder-opened",
            },
          },
          [
            _c(
              "cms-button",
              {
                attrs: { color: "positive", loading: _vm.submitting },
                on: { click: _vm.submit },
              },
              [_vm._v("Opslaan")]
            ),
            _c(
              "cms-button",
              {
                attrs: {
                  color: "medium-dark",
                  type: "bordered",
                  to: { name: "projects" },
                },
              },
              [_vm._v("Annuleren")]
            ),
            _vm.projectId
              ? _c(
                  "cms-button",
                  {
                    staticStyle: { "margin-right": "10px" },
                    attrs: { color: "negative", type: "bordered" },
                    on: { click: _vm.deleteProject },
                  },
                  [_vm._v("Project verwijderen")]
                )
              : _vm._e(),
          ],
          1
        ),
        _c(
          "div",
          {
            directives: [
              {
                name: "spinner",
                rawName: "v-spinner",
                value: _vm.loading,
                expression: "loading",
              },
            ],
            staticClass: "wm-block",
          },
          [
            !_vm.loading
              ? _c(
                  "cms-form",
                  [
                    _c("cms-form-input", {
                      directives: [
                        {
                          name: "validate",
                          rawName: "v-validate",
                          value: "required",
                          expression: "'required'",
                        },
                      ],
                      attrs: {
                        title: "Titel",
                        name: "title",
                        "data-vv-name": "title",
                        "data-vv-as": "Titel",
                        error: _vm.error("title"),
                      },
                      model: {
                        value: _vm.editProject.title,
                        callback: function ($$v) {
                          _vm.$set(_vm.editProject, "title", $$v)
                        },
                        expression: "editProject.title",
                      },
                    }),
                    _c("cms-form-input", {
                      directives: [
                        {
                          name: "validate",
                          rawName: "v-validate",
                          value: "required",
                          expression: "'required'",
                        },
                      ],
                      attrs: {
                        title: "Code",
                        name: "code",
                        "data-vv-name": "code",
                        "data-vv-as": "Code",
                        error: _vm.error("code"),
                      },
                      model: {
                        value: _vm.editProject.code,
                        callback: function ($$v) {
                          _vm.$set(_vm.editProject, "code", $$v)
                        },
                        expression: "editProject.code",
                      },
                    }),
                    _c("cms-form-input", {
                      directives: [
                        {
                          name: "validate",
                          rawName: "v-validate",
                          value: "required",
                          expression: "'required'",
                        },
                      ],
                      attrs: {
                        title: "Organisatie",
                        name: "organisation",
                        "data-vv-name": "organisation",
                        "data-vv-as": "Organisatie",
                        error: _vm.error("organisation"),
                      },
                      model: {
                        value: _vm.editProject.organisation,
                        callback: function ($$v) {
                          _vm.$set(_vm.editProject, "organisation", $$v)
                        },
                        expression: "editProject.organisation",
                      },
                    }),
                    _c("cms-form-input", {
                      directives: [
                        {
                          name: "validate",
                          rawName: "v-validate",
                          value: "required",
                          expression: "'required'",
                        },
                      ],
                      attrs: {
                        title: "Naam contactpersoon",
                        name: "contactperson",
                        "data-vv-name": "contactperson",
                        "data-vv-as": "Contactpersoon",
                        error: _vm.error("contactperson"),
                      },
                      model: {
                        value: _vm.editProject.contactPersonName,
                        callback: function ($$v) {
                          _vm.$set(_vm.editProject, "contactPersonName", $$v)
                        },
                        expression: "editProject.contactPersonName",
                      },
                    }),
                    _c("cms-form-radio", {
                      directives: [
                        {
                          name: "validate",
                          rawName: "v-validate",
                          value: "required",
                          expression: "'required'",
                        },
                      ],
                      attrs: {
                        title: "Status",
                        name: "state",
                        "data-vv-name": "state",
                        "data-vv-as": "Status",
                        options: [
                          { label: "Actief", value: "OPEN" },
                          { label: "Inactief", value: "CLOSED" },
                        ],
                        error: _vm.error("state"),
                      },
                      model: {
                        value: _vm.editProject.state,
                        callback: function ($$v) {
                          _vm.$set(_vm.editProject, "state", $$v)
                        },
                        expression: "editProject.state",
                      },
                    }),
                    _c("cms-form-date-picker", {
                      directives: [
                        {
                          name: "validate",
                          rawName: "v-validate",
                          value: "required",
                          expression: "'required'",
                        },
                      ],
                      attrs: {
                        title: "Start datum",
                        name: "startDate",
                        "data-vv-name": "startDate",
                        "data-vv-as": "Start datum",
                        error: _vm.error("startDate"),
                      },
                      model: {
                        value: _vm.editProject.startDate,
                        callback: function ($$v) {
                          _vm.$set(_vm.editProject, "startDate", $$v)
                        },
                        expression: "editProject.startDate",
                      },
                    }),
                    _c("cms-form-place-searchbar", {
                      attrs: {
                        title: "Locatie",
                        name: "location",
                        value: _vm.editProject.locationTitle,
                      },
                      on: { update: _vm.setPlace },
                    }),
                    _c("div", { staticClass: "divider" }),
                    _vm.users
                      ? _c(
                          "cms-form-row",
                          {
                            staticClass: "linked-users",
                            attrs: { title: "Gekoppelde gebruikers" },
                          },
                          [
                            _c(
                              "div",
                              { staticClass: "top" },
                              [
                                _c("span", { staticClass: "hint" }, [
                                  _vm._v(
                                    "Vink de gebruikers aan die gekoppeld moeten zijn aan dit project"
                                  ),
                                ]),
                                _c("cms-searchbar", {
                                  model: {
                                    value: _vm.usersSearchQuery,
                                    callback: function ($$v) {
                                      _vm.usersSearchQuery = $$v
                                    },
                                    expression: "usersSearchQuery",
                                  },
                                }),
                              ],
                              1
                            ),
                            _c(
                              "div",
                              {
                                directives: [
                                  {
                                    name: "spinner",
                                    rawName: "v-spinner",
                                    value: _vm.loadingUsers,
                                    expression: "loadingUsers",
                                  },
                                ],
                              },
                              [
                                _c(
                                  "table",
                                  {
                                    staticClass:
                                      "table clickable table-linked-users",
                                  },
                                  [
                                    _c(
                                      "cms-table-header",
                                      [
                                        _c(
                                          "cms-th",
                                          { staticStyle: { width: "5%" } },
                                          [
                                            _c("cms-checkbox", {
                                              attrs: {
                                                value:
                                                  _vm.allVisibleUsersSelected,
                                              },
                                              on: {
                                                input:
                                                  _vm.toggleAllVisibleUsers,
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                        _c(
                                          "cms-th",
                                          {
                                            attrs: { field: "firstName" },
                                            model: {
                                              value: _vm.usersSort,
                                              callback: function ($$v) {
                                                _vm.usersSort = $$v
                                              },
                                              expression: "usersSort",
                                            },
                                          },
                                          [_vm._v("Voornaam")]
                                        ),
                                        _c(
                                          "cms-th",
                                          {
                                            attrs: { field: "lastName" },
                                            model: {
                                              value: _vm.usersSort,
                                              callback: function ($$v) {
                                                _vm.usersSort = $$v
                                              },
                                              expression: "usersSort",
                                            },
                                          },
                                          [_vm._v("Achternaam")]
                                        ),
                                        _c(
                                          "cms-th",
                                          {
                                            attrs: { field: "role" },
                                            model: {
                                              value: _vm.usersSort,
                                              callback: function ($$v) {
                                                _vm.usersSort = $$v
                                              },
                                              expression: "usersSort",
                                            },
                                          },
                                          [_vm._v("Rol")]
                                        ),
                                        _c(
                                          "cms-th",
                                          {
                                            attrs: { field: "email" },
                                            model: {
                                              value: _vm.usersSort,
                                              callback: function ($$v) {
                                                _vm.usersSort = $$v
                                              },
                                              expression: "usersSort",
                                            },
                                          },
                                          [_vm._v("E-mail adres")]
                                        ),
                                      ],
                                      1
                                    ),
                                    _vm._l(_vm.users.items, function (user) {
                                      return _c(
                                        "tr",
                                        {
                                          class: {
                                            selected:
                                              _vm.checkedUserIds.indexOf(
                                                user.id
                                              ) >= 0,
                                          },
                                          on: {
                                            click: function ($event) {
                                              return _vm.onUserSelect(user.id)
                                            },
                                          },
                                        },
                                        [
                                          _c(
                                            "td",
                                            {
                                              on: {
                                                click: function ($event) {
                                                  $event.stopPropagation()
                                                },
                                              },
                                            },
                                            [
                                              _c("cms-checkbox", {
                                                attrs: {
                                                  value:
                                                    _vm.checkedUserIds.indexOf(
                                                      user.id
                                                    ) >= 0,
                                                },
                                                on: {
                                                  input: function ($event) {
                                                    return _vm.onUserSelect(
                                                      user.id
                                                    )
                                                  },
                                                },
                                              }),
                                            ],
                                            1
                                          ),
                                          _c("td", [
                                            _vm._v(_vm._s(user.firstName)),
                                          ]),
                                          _c("td", [
                                            _vm._v(_vm._s(user.lastName)),
                                          ]),
                                          _c("td", [
                                            _vm._v(
                                              _vm._s(
                                                _vm._f("userRole")(user.role)
                                              )
                                            ),
                                          ]),
                                          _c("td", [
                                            _vm._v(_vm._s(user.email)),
                                          ]),
                                        ]
                                      )
                                    }),
                                  ],
                                  2
                                ),
                              ]
                            ),
                          ]
                        )
                      : _vm._e(),
                  ],
                  1
                )
              : _vm._e(),
          ],
          1
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }